"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.domainSuffix = exports.isQA = exports.isProd = exports.isDeployed = void 0;

var _enviro = _interopRequireDefault(require("enviro"));

var PROD_KEY = 'prod';
var QA_KEY = 'qa';

var SHORT = _enviro.default.getShort();

var IS_DEPLOYED = _enviro.default.deployed();

exports.isDeployed = IS_DEPLOYED;
var IS_PROD = SHORT === PROD_KEY;
exports.isProd = IS_PROD;
var IS_QA = SHORT === QA_KEY;
exports.isQA = IS_QA;
var domainSuffix = IS_QA ? QA_KEY : '';
/* eslint-env commonjs */
// This temporary hack ensures module system compatibility.
// Read more at go/treeshaking

exports.domainSuffix = domainSuffix;

if (!!module && !!module.exports) {
  module.exports.default = Object.assign({}, module.exports);
}